import {TableColumnType} from "../../../enums/table-column-type";

export enum InvitedUsersTableColumn {
  FirstName = 'first_name',
  LastName = 'last_name',
  WorkEmail = 'work_email',
  Phone = 'phone'
}

export const INVITED_USERS_TABLE_COLUMNS = [
  {
    columnId: InvitedUsersTableColumn.FirstName,
    header: 'First Name',
    type: TableColumnType.Text,
    sortable: true
  },
  {
    columnId: InvitedUsersTableColumn.LastName,
    header: 'Last Name',
    type: TableColumnType.Text,
    sortable: true
  },
  {
    columnId: InvitedUsersTableColumn.WorkEmail,
    header: 'Email',
    type: TableColumnType.Text,
    sortable: true
  },
  {
    columnId: InvitedUsersTableColumn.Phone,
    header: 'Phone',
    type: TableColumnType.Text,
    sortable: true
  }
];
